module.exports = __webpack_public_path__ + "img/heroism_knightfortkn.b89a908.png";